export default __webpack_public_path__ + "static/media/microcentrifuge_topview_lid_closed.a30aa29f.svg";